<template>
  <!-- -->
  <div class="defaultViewStyle">
    <yq-empty :description="title"/>
  </div>
</template>

<script>

export default {
  props: {
    title: {default: "功能暂未上线"}
  },
  name: "",
  components: {
  },
  data() {
    return {

    };
  },
  created() {
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>

</style>